import { Injectable } from '@angular/core';

@Injectable(
    {providedIn: 'root'}
)
export class AttendanceService {
    headerStatus: boolean;
    sideMenuStatus: boolean;
    isMobile: boolean;
    screenWidth: number;
    screenHeight: number;

    set setHeaderStatus(val){
        this.headerStatus = val;
    }
    get getHeaderStatus(){
        return this.headerStatus;
    }
    set setSideMenuStatus(val){
        this.sideMenuStatus = val;
    }
    get getSideMenuStatus(){
        return this.sideMenuStatus;
    }
    set setIsMobile(val){
        this.isMobile = val;
    }
    get getIsMobile(){
        return this.isMobile;
    }

    checkSize() {
        setTimeout(() => {
            this.screenWidth = window.innerWidth;
            this.screenHeight = window.innerHeight;
        if(this.screenWidth < 768){
            this.setIsMobile = true;
            this.setSideMenuStatus= false;
        }else {
          this.setIsMobile = false;
          this.setSideMenuStatus= true;
        }
        
        }, 1)
        
    }
}
